import { render, staticRenderFns } from "./qualityManage.vue?vue&type=template&id=3a682b3f&scoped=true&"
import script from "./qualityManage.vue?vue&type=script&lang=tsx&"
export * from "./qualityManage.vue?vue&type=script&lang=tsx&"
import style0 from "./qualityManage.vue?vue&type=style&index=0&id=3a682b3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a682b3f",
  null
  
)

export default component.exports